export const paths = {
  auth: "/login",
  profile: "/profile",
  home: "/",
  individuals: "/individuals",
  taxonomicGroups: "/taxonomic-groups",
  managingReleases: "/managing-releases",
  reports: "/reports",
  registers: "/registers",
  samples: "/samples",
  community: "/community",
  devices: "/devices",
  users: "/users",
  notifications: "/notifications",
} as const;
